import React from "react";
import AboutSection2 from "../About/AboutSection2";
import aboutHome1 from "../../Image/aboutHome1.png";
import aboutHome2 from "../../Image/aboutHome2.png";
import Wave from "react-wavify";

const About = () => {
  return (
    <div className="relative overflow-hidden">
      <img
        src={aboutHome1}
        alt="image1"
        className="absolute top-0  left-[-2%] h-full z-[0]"
      ></img>
      <img
        src={aboutHome2}
        alt="image2"
        className="absolute top-0 hidden lg:block right-[0%] h-full z-[0]"
      ></img>
      <div className="relative z-[1]">
        <div className="text-center w-[90%] 3xl:w-[30%] 2xl:w-[40%] lg:w-[60%] sm:w-[80%] m-auto pb-8">
          <h1 className="uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-[#141414] leading-[40px]   2xl:leading-[60px]">
            About
          </h1>
          <h1 className="uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-theme_dark  leading-[40px]   2xl:leading-[60px]">
            KALATHIYA INFOTECH
          </h1>
          <p className="px-2 text-sm  2xl:text-base text-[#000000B2] mt-3">
            Kalathiya Infotech is a dynamic IT company dedicated to delivering
            cutting-edge solutions that empower businesses to thrive in the
            digital age. With a focus on innovation, reliability, and customer
            satisfaction, we have established ourselves as a trusted partner for
            businesses worldwide.
          </p>
        </div>
        <AboutSection2 />
      </div>
      <Wave
        fill="#F0E3FF"
        paused={false}
        style={{ display: "flex" }}
        options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }}
        className="relative min-w-[1920px] h-[28px] bg_theme-light"
      />
    </div>
  );
};

export default About;
